import styled from 'styled-components';

export const StyledAuthFooter = styled.footer`
  text-align: center;

  img {
    height: 20px;
    align-self: start;
  }
`;
